import React from "react";
import "../styles/Intro.css";
import { FiCalendar } from "react-icons/fi";

// Crossfaded by CSS (16s loop, 4s each) — keep in sync with the hero-shot keyframes
const HERO_SHOTS = [
  "/assets/dashboards/financial/finance.webp",
  "/assets/dashboards/procurement/sc.webp",
  "/assets/dashboards/financial/ar.webp",
  "/assets/dashboards/hr/hr_analytics_main.webp",
];

const Intro = () => {
  return (
    <div className="intro-section">
      <div className="intro-content">
        <div className="typist-content">
          <h1 className="text-typing-container">
            <span className="intro-title">Hi there! I'm{" "}</span>
            <span className="intro-name">Faizaan.</span>
          </h1>
        </div>
        <div className="intro-subtitle">
          An <span className="intro-subtitle-name">SAP & Agentic BI Consultant</span>
        </div>

        <div className="intro-desc">
          I turn your SAP data into Power BI dashboards and reporting that runs itself: scheduled email
          reports, KPI alerts and mismatch checks built with Python and AI agents. Your team stops
          building spreadsheets and starts making decisions.
        </div>

        <ul className="intro-proof">
          <li>50+ dashboards delivered</li>
          <li>SAP FI · CO · SD · MM · PP · HCM</li>
          <li>Up to 70% less manual reporting</li>
        </ul>

        <div className="intro-buttons">
          <a href="#contact" className="outline-button primary btn-effect">Book a Free Discovery Call <FiCalendar className="button-icon" /></a>
          <a href="#projects" className="intro-link">See live dashboards &rarr;</a>
        </div>
      </div>

      <div className="intro-animation">
        <div className="hero-shots" role="img" aria-label="Sample Power BI dashboards built on SAP data">
          {HERO_SHOTS.map((src, i) => (
            <img key={src} src={src} alt="" decoding="async" style={{ animationDelay: `${i * 4}s` }} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Intro;
